import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import * as fileSaver from "file-saver";
import { ApplicationSettings } from "src/app/shared/models/application-settings";
import { IInvoiceSummary } from "src/app/shared/models/invoices";
import { ThemeService } from "src/app/shared/services/theme.service";
import { ApplicationSettingsService } from "../../application-settings/application-settings.service";
import { FacturationService } from "../services/facturation.service";
import { SnackbarService } from '../../../shared/services/snackbar.service';

@Component({
  selector: 'app-facturation-import',
  templateUrl: './facturation-import.component.html',
  styleUrls: ['./facturation-import.component.less']
})
export class FacturationImportComponent implements OnInit {

  public invoiceFile!: File;
  public yearSelected!: number;
  public years: number[] = [];
  public canExport = true;
  public currentYear: number = new Date().getFullYear();
  public spinner = false;
  public invoiceSummary!: MatTableDataSource<IInvoiceSummary>;
  public monthNames: string[] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"];
  public displayedColumns: string[] = ["month", "packYear", "totalInvoice", "nbInvoices"];
  public totalInvoicesByPackYear: { [key: number]: { total: number, count: number } } = {};

  public month!: string;
  private applicationSettings: ApplicationSettings;

  constructor(private applicationSettingsService: ApplicationSettingsService,
              private facturationService: FacturationService,
              public theme: ThemeService,
              private snackbarService: SnackbarService) {

    this.applicationSettings = this.applicationSettingsService.getApplicationSettings();
    for (let i = (this.currentYear - 2); i < (this.currentYear + 2); i++) {
      this.years.push(i);
    }

    this.yearSelected = this.currentYear;
    this.invoiceSummary = new MatTableDataSource<IInvoiceSummary>();
  }

  ngOnInit(): void {
    this.updateInvoiceSummary();
  }

  updateInvoiceSummary() {
    this.facturationService.getInvoiceSummary(this.yearSelected).subscribe({
      next: (res: IInvoiceSummary[]) => {
        this.invoiceSummary.data = res;
        this.calculateTotals();
      },
      error: (err: any) => {
        console.log(err);
        this.openErrorSnackBar('Erreur lors de la récupération des données');
      },
      complete: () => {}
    });
  }

  calculateTotals() {
    this.totalInvoicesByPackYear = this.invoiceSummary.data.reduce((acc, curr) => {
      if (!acc[curr.pack_year]) {
        acc[curr.pack_year] = { total: 0, count: 0 };
      }
      acc[curr.pack_year].total += curr.total_mois;
      acc[curr.pack_year].count += curr.nbre_factures;
      return acc;
    }, {} as { [key: number]: { total: number, count: number } });
  }

  getPackYears(): number[] {
    return Object.keys(this.totalInvoicesByPackYear)
      .map(year => parseInt(year, 10))
      .sort((a, b) => b - a);
  }

  uploadFile(event: any) {
    if (this.applicationSettings.JIRA_Radical != null
      && this.applicationSettings.JIRA_Radical.trim() != ""
      && this.invoiceFile.name.indexOf(this.applicationSettings.JIRA_Radical.trim()) == -1) {
      this.openErrorSnackBar('Import impossible: Le nom de fichier ' + this.invoiceFile.name + ' ne correspond pas au radical indiqué.')
    } else {
      this.spinner = true;

      this.facturationService.uploadInvoiceFile(this.invoiceFile).subscribe({
        next: (data: string) => {
          this.openSuccessSnackBar("Le fichier s'est correctement importé.");
        },
        error: (err: string) => {
          console.log(err);
          this.openErrorSnackBar("Le fichier n'est pas importé.");
          this.spinner = false;
        },
        complete: () => {
          this.updateInvoiceSummary();
          this.spinner = false;
        }
      });
    }
  }

  exportInvoice(year: number): void {
    this.spinner = true;

    this.facturationService.exportInvoice(year).subscribe({
      next: data => {
        const blob: any = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        window.URL.createObjectURL(blob);
        fileSaver.saveAs(blob, "Factures " + year + " (" + this.applicationSettingsService.applicationSettings.CDS_name + ")");
      },
      error: err => {
        console.log(err);
      },
      complete: () => {
        this.spinner = false;
      }
    });
  }

  changeYear(year: number): void {
    this.yearSelected = year;
    this.updateInvoiceSummary();
  }

  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }

}